import { render, staticRenderFns } from "./CreateMultiProductDashboard.vue?vue&type=template&id=44fc9512&scoped=true&"
import script from "./CreateMultiProductDashboard.vue?vue&type=script&lang=js&"
export * from "./CreateMultiProductDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CreateMultiProductDashboard.vue?vue&type=style&index=0&id=44fc9512&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fc9512",
  null
  
)

export default component.exports